import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMultiLanguage = props => /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  ...props,
  children: /*#__PURE__*/_jsxs("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M0 0h24v24H0z"
    }), /*#__PURE__*/_jsx("circle", {
      cx: 6.5,
      cy: 12.5,
      r: 4,
      fill: "currentColor",
      stroke: "currentColor"
    }), /*#__PURE__*/_jsx("circle", {
      cx: 17.5,
      cy: 12.5,
      r: 4,
      stroke: "currentColor"
    })]
  })
});
export default SvgMultiLanguage;